import { render, staticRenderFns } from "./TableHolders.vue?vue&type=template&id=7a186c5e&scoped=true&"
import script from "./TableHolders.vue?vue&type=script&lang=js&"
export * from "./TableHolders.vue?vue&type=script&lang=js&"
import style0 from "./TableHolders.vue?vue&type=style&index=0&id=7a186c5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a186c5e",
  null
  
)

export default component.exports